import { isDemoActive } from "./demoFlag";

type RunLoadOptions<TData> = {
  isLoading?: () => boolean;
  setLoading?: (loading: boolean) => void;
  setError?: (message: string | null) => void;
  setHydrated?: (hydrated: boolean) => void;
  hydrateOnError?: boolean;
  fetcher: () => Promise<TData>;
  onSuccess: (data: TData) => void | Promise<void>;
  errorMessage?: string;
};

export async function runLoad<TData>({
  isLoading,
  setLoading,
  setError,
  setHydrated,
  hydrateOnError,
  fetcher,
  onSuccess,
  errorMessage,
}: RunLoadOptions<TData>) {
  if (isLoading?.()) return;
  setLoading?.(true);
  setError?.(null);
  try {
    const data = await fetcher();
    if (isDemoActive()) return;
    await onSuccess(data);
    setHydrated?.(true);
  } catch (error: any) {
    if (isDemoActive()) return;
    if (hydrateOnError) {
      setHydrated?.(true);
    } else {
      setHydrated?.(false);
    }
    setError?.(error?.message || errorMessage || "Failed to load");
  } finally {
    setLoading?.(false);
  }
}
